import { formatVolume, IFormattingSettings, VolumeUnit } from '@fulcrum/lib';
import * as Converter from '../unit-of-measure/volume-converter';
import { BaseFormatterProps } from './base-formatter-props.types';
import { t } from '@trimble/i18n';

/**
 * The conversion is achieved by first converting to cubic meters (m3) as an intermediate step.
 * The 'fulcrum' library uses m3 as its base unit for volume.
 *
 * @remarks Trimble APIs should store and return area in base metric.
 *
 * @regex ^-?\d+(\.\d+)?\s?(mm3|cm3|m3|in3|ft3)$
 * - TODO: Refine this regex to better match possible outputs.
 */
export const toDisplay = ({
  measuredValue,
  currentUnits,
  settings,
}: BaseFormatterProps<number, VolumeUnit, IFormattingSettings>): string => {
  let measuredValueInMeters;
  if (currentUnits !== 'm3') {
    // Convert to mm first due to fulcrum lib using mm as base unit
    measuredValueInMeters = Converter.mapToMeters({
      value: measuredValue,
      baseUnit: currentUnits,
    });
  } else {
    measuredValueInMeters = measuredValue;
  }
  if (measuredValueInMeters !== null) {
    return formatVolume(
      measuredValueInMeters,
      settings.volumeUnit ?? 'm3',
      settings.volumeDecimals
    );
  } else {
    return t('Utilities.Formatting.InvalidUnit', {
      defaultValue: 'Invalid Unit',
    });
  }
};
